import React from 'react';
import MaintenanceImg from 'assets/img/maintenance.png';
import { Link } from 'react-router-dom';

function Maintenance() {
  return (
    <div className="wrapper">
      <div className="main">
        <div className="container-fluid p-0 h-100">
          <div
            className="d-flex justify-content-center align-items-center my-auto h-100"
            style={{ margin: '0 auto', flexDirection: 'column' }}
          >
            <img
              className=""
              src={MaintenanceImg}
              alt=""
              style={{ width: '20%' }}
            />
            <div
              className="card col-6 h-10 my-3 text-center p-3"
              style={{
                maxHeight: '100px',
              }}
              dangerouslySetInnerHTML={{
                __html: process.env.REACT_APP_MAINTENANCE_TEXT,
              }}
            />

            {/* <Link to="/">Back to home</Link> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Maintenance;
